(function ($) {
    'use strict';

    function initUsersTable() {
        const tableElement = document.getElementById('usersTable');
        if (!tableElement) {
            return;
        }

        new DataTable('#usersTable', {
            pageLength: 25,
            order: [[1, 'asc']],
            responsive: false,
            autoWidth: false,
            columnDefs: [
                { orderable: false, targets: [9] }
            ],
            layout: {
                topStart: {
                    buttons: [
                        {
                            extend: 'collection',
                            text: '<i class="bi bi-download me-1"></i>Export',
                            attr: {class: 'btn btn-sm btn-outline-secondary'},
                            buttons: [
                                {
                                    extend: 'copyHtml5',
                                    text: '<i class="bi bi-clipboard me-1"></i>Copy',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                },
                                {
                                    extend: 'csvHtml5',
                                    text: '<i class="bi bi-filetype-csv me-1"></i>CSV',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                },
                                {
                                    extend: 'excelHtml5',
                                    text: '<i class="bi bi-file-earmark-excel me-1"></i>Excel',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                },
                                {
                                    extend: 'pdfHtml5',
                                    text: '<i class="bi bi-file-earmark-pdf me-1"></i>PDF',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    },
                                    orientation: 'landscape',
                                    pageSize: 'A4'
                                },
                                {
                                    extend: 'print',
                                    text: '<i class="bi bi-printer me-1"></i>Print',
                                    exportOptions: {
                                        columns: ':not(:last-child)'
                                    }
                                }
                            ]
                        },
                        {
                            extend: 'colvis',
                            text: '<i class="bi bi-layout-three-columns me-1"></i>Columns',
                            attr: {class: 'btn btn-sm btn-outline-secondary'}
                        }
                    ]
                },
                topEnd: {
                    search: {
                        placeholder: 'Search users'
                    }
                },
                bottomStart: 'info',
                bottomEnd: 'paging'
            }
        });
    }

    function bindResetPasswordModal() {
        $(document).on('click', '.btn-reset-password', function () {
            const btn = $(this);

            $('#reset_user_id').val(btn.data('user-id'));
            $('#reset_user_label').text(btn.data('display-name') || '-');
            $('#reset_user_email').text(btn.data('email') || '-');
            $('#resetPasswordModal input[name="password"]').val('');
            $('#resetPasswordModal input[name="password_confirm"]').val('');
        });
    }

    function bindUserEditForm() {
        $(document).on('submit', '[data-user-edit-form]', function (event) {
            const form = event.currentTarget;
            if (form.dataset.submitting === '1') {
                event.preventDefault();
                return;
            }

            form.dataset.submitting = '1';
            const submit = form.querySelector('[data-user-edit-submit]');
            if (submit) {
                submit.disabled = true;
                submit.innerHTML = '<span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>Saving...';
            }
        });
    }

    $(function () {
        initUsersTable();
        bindResetPasswordModal();
        bindUserEditForm();
    });

})(jQuery);
